import ShowMoreContent from 'shared/show_more_content';
import $ from 'jquery';

export default class ShowMoreCommentContent {
  init() {
    this.bindAjaxSuccess('#dropdown-comment-newest-first');
    this.bindAjaxSuccess('#dropdown-comment-top-comments');
  }

  bindAjaxSuccess(selector) {
    $(document).on('ajax:success', selector, function(){
      new ShowMoreContent('.js-comment-container', '.truncate .read-more-comment', '.hidden');
    });
  }
}
